module.exports = "/_next/static/images/OptimizeSyncRuns@2x-f2b015861423a05d615b3fb185fc18ff.png";